/** Operator-facing names for `ai_request_logs.error_kind`. */
export const ERROR_KIND_LABELS: Record<string, string> = {
  provider_unavailable: 'Provider down',
  timeout: 'Timed out',
  bad_request: 'Rejected',
  config: 'Misconfigured',
  other: 'Failed',
  pre_request: 'Failed before model call',
}

/** Operator-facing names for `ai_request_logs.model_role` (which candidate served the attempt). */
export const MODEL_ROLE_LABELS: Record<string, string> = {
  primary: 'Primary',
  fallback: 'Fallback',
}
